import { useEffect, useRef, useState } from "react";
import useReducedMotion from "components/Overlays/useReducedMotion";

export const REVEAL_EXIT_MS = 520;
export default function useBookRevealPresence(book, route) {
	const reduced = useReducedMotion();
	const open = Boolean(book);
	const [present, setPresent] = useState(Boolean(book));
	const retained = useRef(book);
	const origin = useRef(route);
	const wasOpen = useRef(false);
	if (book && !wasOpen.current) origin.current = route;
	wasOpen.current = Boolean(book);
	if (book) retained.current = book;
	const routeChanged = origin.current !== route;
	useEffect(() => {
		if (routeChanged) { setPresent(false); return undefined; }
		if (open) { setPresent(true); return undefined; }
		if (!present) return undefined;
		if (reduced || routeChanged) { setPresent(false); return undefined; }
		const timer = setTimeout(() => setPresent(false), REVEAL_EXIT_MS);
		return () => clearTimeout(timer);
	}, [open, present, reduced, route, routeChanged]);
	return { shown: !routeChanged && (Boolean(book) || present), book: book || retained.current, closing: !book, reduced };
}
